import React, {useState} from "react";
import "./journal-card.scss";
import {BsThreeDots} from "react-icons/bs";
import {Dropdown, notification} from "antd";
import {
  CSVIcon,
  DeleteIcon,
  DPDFIcon,
  EditIcon,
  ExcelFIcon,
  ExportIcon,
} from "../../../../../assets/icons/dropdownIcons";
import {GcopyIcon} from "../../../../../assets/icons/cardIcons";
import {useNavigate} from "react-router";
import ActionModal from "../../../common/modals/action-modal/ActionModal";
import {JournalService, JournalService as JournaleService,} from "../../../../services/journals-api.service";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";

const DespFunc = ({ des }) => {
  const paragraphs = des?.split(/\n{2,}/)?.map((para, paraIndex) => {
    const lines = para?.split("\n")?.map((line, lineIndex) => (
      <React.Fragment key={`${paraIndex}-${lineIndex}`}>
        {line}
        <br />
      </React.Fragment>
    ));

    return lines;
  });

  return <h5>{paragraphs}</h5>;
};

export default function JournalCard({ type, answer, id, date, data }) {
  const navigate = useNavigate();
  const [deleteJournal, setDeletejournal] = useState(false);
  const [loader, setLoader] = useState(false);

  async function DeleteJournal(id) {
    setLoader(true);
    const response = await JournaleService.deleteJournal(id);
    if (response?.data?.data?.status) {
      notification.success({
        message: "Success",
        description: "Journal added Successfully",
        placement: "topRight",
        icon: <RoundedCheck />,
        duration: 2,
      });
      setDeletejournal(false);
      setLoader(false);
      navigate("/journals");
    } else {
      notification.success({
        message: "Success",
        description: "Gratitude added Successfully",
        placement: "topRight",
        icon: <RoundedCheck />,
        duration: 2,
      });
      setLoader(false);
    }
  }

  async function GetJournals(journalId, exportType) {
    let exportExcel = false;
    let exportPdf = false;
    let exportCsv = false;
    let redirectKey = "";

    switch (exportType) {
      case 10:
        exportExcel = true;
        redirectKey = "excel";
        break;
      case 20:
        exportPdf = true;
        redirectKey = "pdf";
        break;
      case 30:
        exportCsv = true;
        redirectKey = "csv";
        break;
      default:
        break;
    }

    const response = await JournalService.getJournal(
      "",
      journalId,
      exportCsv,
      exportExcel,
      exportPdf
    );
    if (response?.data?.data?.status) {
      window.open(response?.data?.data?.[redirectKey]);
    }
  }

  const items = [
    {
      key: "1",
      label: (
        <span>
          <ExportIcon /> Export Journal
        </span>
      ),
      children: [
        {
          key: "1-1",
          label: (
            <span
              onClick={() => {
                GetJournals(id, 30);
              }}
            >
              <CSVIcon /> CSV
            </span>
          ),
        },
        {
          key: "1-2",
          label: (
            <span
              onClick={() => {
                GetJournals(id, 20);
              }}
            >
              <DPDFIcon /> PDF
            </span>
          ),
        },
        {
          key: "1-3",
          label: (
            <span
              onClick={() => {
                GetJournals(id, 10);
              }}
            >
              <ExcelFIcon /> EXCEL
            </span>
          ),
        },
      ],
    },
    {
      key: "2",
      label: (
        <span
          onClick={() => {
            navigate(`/journals/edit/${id}`);
          }}
        >
          <EditIcon /> Edit Journal
        </span>
      ),
    },
    {
      key: "3",
      label: (
        <span
          onClick={() => {
            setDeletejournal(true);
          }}
        >
          <DeleteIcon /> Delete Journal
        </span>
      ),
    },
    // {
    //     key: '4',
    //     label: <span><DDownloadIcon/> Download Journal</span>,
    // },
  ];

  return (
    <div className={"journal-detail-card"}>
      <p>
        <GcopyIcon />
        <span>
          <Dropdown menu={{ items }} placement="bottomLeft" trigger={"click"}>
            <BsThreeDots />
          </Dropdown>
        </span>
      </p>
      {type === "re-frame" ? (
        <div>
          {data?.map((item, index) => {
            return (
              <ul>
                <li>
                  <h4>{item.label}</h4>
                  <h5 style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }} className={'section-para'}>
                    {item.text}
                  </h5>
                </li>
              </ul>
            );
          })}
        </div>
      ) : (
        <div>
          {data?.map((item, index) => {
            return (
              <>
                <DespFunc des={item.text} />
              </>
            );
          })}
        </div>
      )}
      <ActionModal
        show={deleteJournal}
        close={setDeletejournal}
        modalHeading={"Delete Journal"}
        modalText={"Are you sure you want to delete?"}
        cancelBTnText={"Cancel"}
        actionBTnText={"Delete"}
        // loader={loader}
        actionBtnFunc={() => {
          DeleteJournal(id);
        }}
        loader={loader}
      />
    </div>
  );
}
